import { defineMessages } from 'react-intl';

export const errorMessages = defineMessages({
  trackingNotInitializedTitle: { id: 'error_overlay.tracking_not_initialized_title' },
  trackingNotInitializedDescription: { id: 'error_overlay.tracking_not_initialized_description' },
  courseUnavailableTitle: { id: 'error_overlay.course_unavailable_title' },
  courseUnavailableDescription: { id: 'error_overlay.course_unavailable_description' },
  unknownLoadingTitle: { id: 'error_overlay.unknown_loading_title' },
  unknownLoadingDescription: { id: 'error_overlay.unknown_loading_description' },
  somethingWentWrongTitle: { id: 'error_overlay.something_went_wrong_title' },
  serverErrorDescription: { id: 'error_overlay.server_error_description' },
  reloadHint: { id: 'error_overlay.reload_hint' },
  reload: { id: 'error_overlay.reload' },
  hideDetails: { id: 'error_overlay.hide_details' },
  showDetails: { id: 'error_overlay.show_details' },
  errorName: { id: 'error_overlay.error_name' },
  errorMessage: { id: 'error_overlay.error_message' },
  errorStackTrace: { id: 'error_overlay.error_stack_trace' },
});
